import React, { FC } from 'react'
import { i18n } from 'LibNeo/utils'
import { UISizes, UITypes } from 'LibNeo/constants/UIConstants'
import { IconComponent } from 'LibNeo/components/Basic/Icon/Icon'
import { Description, IconWrapper, Item, TextWrapper, Title } from './styled'

export enum FormNavigationTypes {
	Default,
	Warning,
	Locked,
	Completed,
	Error,
	Validated,
}

export type FormNavigationItem = {
	title: string
	description?: string
	type?: FormNavigationTypes
	onClick?: (event: React.MouseEvent) => void
	active?: boolean
	isView?: boolean
	idx?: number
}

export type FormNavigationProps = {
	items: FormNavigationItem[]
	className?: string
}

export const iconsByType: Record<FormNavigationTypes, JSX.Element> = {
	[FormNavigationTypes.Default]: (
		<IconComponent name="time" type={UITypes.PASSIVE} size={UISizes.SMALL} />
	),
	[FormNavigationTypes.Warning]: (
		<IconComponent name="time" type={UITypes.WARNING} size={UISizes.SMALL} />
	),
	[FormNavigationTypes.Locked]: (
		<IconComponent name="lock" type={UITypes.PASSIVE} size={UISizes.SMALL} />
	),
	[FormNavigationTypes.Completed]: (
		<IconComponent name="check-circle" type={UITypes.PRIMARY} size={UISizes.SMALL} />
	),
	[FormNavigationTypes.Validated]: (
		<IconComponent name="time" type={UITypes.PRIMARY} size={UISizes.SMALL} />
	),
	[FormNavigationTypes.Error]: (
		<IconComponent name="error" type={UITypes.DANGER} size={UISizes.SMALL} />
	),
}

export const FormNavigation: FC<FormNavigationProps> = ({ items, className }) => (
	<nav className={className}>
		{items.map(({ title, description, type, onClick, active, isView }) =>
			isView ?? true ? (
				<Item onClick={onClick} key={`${title}-${description}`} active={active}>
					{typeof type === 'number' && <IconWrapper>{iconsByType[type]}</IconWrapper>}
					<TextWrapper>
						<Title>{i18n(title)}</Title>
						{description && <Description>{i18n(description)}</Description>}
					</TextWrapper>
				</Item>
			) : null
		)}
	</nav>
)
